import { IComponentController } from '@wix/editor-elements-types';
import { IAddressInputControllerActions } from '../AddressInput.types';

const mapActionsToProps: IComponentController = ({
  updateProps,
  reportBi,
}): IAddressInputControllerActions => ({
  onChange: ({ target: { value } }) => updateProps({ value }),
  onBI: (event, extra = {}) => reportBi(event, extra),
});

export default mapActionsToProps;
